/* Load an embedded map only when its disclosure is opened. The Google Maps
   link remains available without JavaScript. */
document.addEventListener('toggle', (event) => {
  const disclosure = event.target;
  if (!(disclosure instanceof HTMLDetailsElement) ||
      !disclosure.matches('.wlp-map-disclosure') || !disclosure.open) return;
  const template = disclosure.querySelector('template');
  const canvas = disclosure.querySelector('.wlp-map-canvas');
  if (!template || !canvas || canvas.childElementCount) return;
  canvas.append(template.content.cloneNode(true));
}, true);
